export const barChartMetadata = {
  allowConnectToDB: true
};
